module.exports = __webpack_public_path__ + "img/book-section.71627255.svg";